export const SET_TITLE = 'SET_TITLE';
export const SECOND_ID = "SECOND_ID";


// WEBPACK FOOTER //
// ./src/store/mutations-type.js